// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    overflow-y: scroll;
    background: rgba(239, 236, 239, 0);
    margin: 0;
    padding: 0;
}

.privacy-policy-container {
  background: rgba(234, 229, 234, 1); /* 60% translucent */
  max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    background-color: white; /* Keep privacy policy content on a white background */
    border-radius: 10px; /* Optional: Adds rounded corners */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Optional: Adds a subtle shadow */
    text-align: left; /* Center align content */
  }
  
  .logo-container {
    text-align: center;
    justify-content: center;
    justify-items: center;
    margin-bottom: 20px;
  }
  
  .company-logo {
    width: 150px; /* Adjust size */
    height: auto;
  }
  
  .ps-company-header-h1 {
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;  
    font-size: 60px;
    color: black; 
    font-weight: lighter;
  }

  .ps-company-header-h2 {
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;  
    font-size: 30px;
    color: black; 
    font-weight: lighter;
    margin-top: 10px;
  }

  .ps-company-header-h3 {
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;  
    font-size: 24px;
    color: black; 
    font-weight: lighter;
    margin-top: 10px; 
  }

  .ps-company-text {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;  
    font-size: 16px;
    color: black; 
    margin-top: 5px;
  }

  .ps-company-text-li {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;  
    font-size: 16px;
    color: black; 
    margin-top: 5px;
  }`, "",{"version":3,"sources":["webpack://./src/components/Pages/PublicLayout/PrivacyPolicy/PrivacyPolicy.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,SAAS;IACT,UAAU;AACd;;AAEA;EACE,kCAAkC,EAAE,oBAAoB;EACxD,gBAAgB;IACd,cAAc;IACd,aAAa;IACb,uBAAuB,EAAE,sDAAsD;IAC/E,mBAAmB,EAAE,mCAAmC;IACxD,wCAAwC,EAAE,mCAAmC;IAC7E,gBAAgB,EAAE,yBAAyB;EAC7C;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,YAAY,EAAE,gBAAgB;IAC9B,YAAY;EACd;;EAEA;IACE,6EAA6E;IAC7E,eAAe;IACf,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,6EAA6E;IAC7E,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,6EAA6E;IAC7E,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,mJAAmJ;IACnJ,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,mJAAmJ;IACnJ,eAAe;IACf,YAAY;IACZ,eAAe;EACjB","sourcesContent":["body {\n    overflow-y: scroll;\n    background: rgba(239, 236, 239, 0);\n    margin: 0;\n    padding: 0;\n}\n\n.privacy-policy-container {\n  background: rgba(234, 229, 234, 1); /* 60% translucent */\n  max-width: 800px;\n    margin: 0 auto;\n    padding: 20px;\n    background-color: white; /* Keep privacy policy content on a white background */\n    border-radius: 10px; /* Optional: Adds rounded corners */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Optional: Adds a subtle shadow */\n    text-align: left; /* Center align content */\n  }\n  \n  .logo-container {\n    text-align: center;\n    justify-content: center;\n    justify-items: center;\n    margin-bottom: 20px;\n  }\n  \n  .company-logo {\n    width: 150px; /* Adjust size */\n    height: auto;\n  }\n  \n  .ps-company-header-h1 {\n    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;  \n    font-size: 60px;\n    color: black; \n    font-weight: lighter;\n  }\n\n  .ps-company-header-h2 {\n    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;  \n    font-size: 30px;\n    color: black; \n    font-weight: lighter;\n    margin-top: 10px;\n  }\n\n  .ps-company-header-h3 {\n    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;  \n    font-size: 24px;\n    color: black; \n    font-weight: lighter;\n    margin-top: 10px; \n  }\n\n  .ps-company-text {\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;  \n    font-size: 16px;\n    color: black; \n    margin-top: 5px;\n  }\n\n  .ps-company-text-li {\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;  \n    font-size: 16px;\n    color: black; \n    margin-top: 5px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
